import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=58f38387&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=58f38387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f38387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f38387')) {
      api.createRecord('58f38387', component.options)
    } else {
      api.reload('58f38387', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=58f38387&scoped=true&", function () {
      api.rerender('58f38387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X6nim3Rxa1gq/JS/comp/GuestBox.vue"
export default component.exports